import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '../field.interface';
import { AppService } from '@app/app.service';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { AppHelper } from '@app/core/app.helper';
import { Moment } from 'moment';

@Component({
    selector: 'app-month',
    templateUrl: './month.component.html',
    styleUrls: ['./month.component.css'],
})
export class MonthComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;
    monthsList: any;
    monthListObject: any = [];

    constructor(public appService: AppService) {
        moment.locale(AppHelper.getCurrentLanguage(appService).lang);
        this.monthsList = moment.months();
    }

    ngOnInit(): void {
        this.monthsList.forEach((val, index) => {
            this.monthListObject.push({
                id: String(index + 1),
                name: val,
            });
        });
        const value = this.group.get(this.field.name).value as Moment | string;
        if (value && typeof value === 'object' && value.constructor.name === 'Moment') {
            this.group.get(this.field.name).setValue(value.format('MM'), { eventEmit: false });
        }

        if (this.field.disabled) {
            setTimeout(() => {
                this.group.get(this.field.name).disable({ onlySelf: true, emitEvent: false });
            });
        }
    }

    /**
     * Изменить доступность редактирования значения компоненты
     * @param disabled Компонента доступна или недоступна для редактирования?
     */
    setDisabled(disabled: boolean) {
        this.field.disabled = disabled;
        if (this.field.disabled) {
            this.group.get(this.field.name).disable({ onlySelf: true, emitEvent: false });
        } else {
            this.group.get(this.field.name).enable({ onlySelf: true, emitEvent: false });
        }
    }
}
